import { Badge, Group } from '@mantine/core'
import { useIntl } from 'react-intl'

type VlmResultTagsProps = {
  tags: string[]
  alertTags: string[]
  limit?: number
}

export const VlmResultTags = ({
  tags,
  alertTags,
  limit = 3
}: VlmResultTagsProps) => {
  const intl = useIntl()

  const allTags = [
    ...alertTags.map((tag) => ({ tag, isAlert: true })),
    ...tags.map((tag) => ({ tag, isAlert: false }))
  ]
  const visible = allTags.slice(0, limit)
  const remaining = allTags.length - visible.length

  return (
    <Group gap={4} maw={260}>
      {visible.map(({ tag, isAlert }) => (
        <Badge
          key={`${isAlert ? 'alert' : 'tag'}-${tag}`}
          size="xs"
          variant="light"
          color={isAlert ? 'red' : undefined}
        >
          {tag}
        </Badge>
      ))}

      {remaining > 0 && (
        <Badge size="xs" variant="light" color="gray">
          {intl.formatMessage({ id: 'general.plusMore' }, { count: remaining })}
        </Badge>
      )}
    </Group>
  )
}
